<template>
  <vx-card v-show="isCardActiveLocal" :style="{ 'background-color': question && question.quizDetails.isGraded ? 'rgba(255, 204, 0, 0.3)' : 'none', 'margin-bottom': '1rem' }">
    <div class="vx-row">
      <div class="vx-col w-full">
        <h5 class="mb-2">{{ answer.questionNumber }}. {{ questionTitle }}</h5>
        <p class="mb-2">{{ questionText }}</p>
        <div>
          <ag-grid-vue
            ref="agGridTable"
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            :columnDefs="answer.tableColumns"
            :rowData="answer.tableRows"
            :defaultColDef="defaultColDef"
            colResizeDefault="shift"
            :animateRows="true">
          </ag-grid-vue>
          <span class="table-swipe-label centereverything w-full" style="margin-top: -4rem !important;padding-bottom: 2rem;"><small>Swipe to see more</small><feather-icon class="pl-2" icon="ArrowRightIcon" svg-classes="stroke-current h-3 w-3"></feather-icon></span>
        </div>
      </div>
    </div>
    <comment-view :isCardActive="commentView" :question="question" :answer="answer" :viewOnly="viewOnly" />
  </vx-card>
</template>

<script>
  import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
  import { AgGridVue } from 'ag-grid-vue'
  import commentView from './QuizCommentView.vue';
  export default {
    components: {
      commentView,
      AgGridVue
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      answer: {
        type: Object,
        required: false
      },
      viewOnly: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        commentView: true,
        questionText: "",
        questionTitle: "",
        gridApi: null,
        gridOptions: {},
        defaultColDef: {
          sortable: false,
          editable: true,
          resizable: true,
          suppressMenu: true,
          suppressMovable: true,
        },
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(self.question){

          }else{
            self.initValues();
          }
        }
      },
      question: function(val) {
        if(val){
          this.commentView = true;
        }
      }
    },
    methods: {
      strip(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
      },
      saveData() {
        this.initValues();
        this.$emit('saveData');
      },
      initValues() {
        
        this.errors.clear();
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
    },
    mounted() {
      if(this.answer){
        this.questionText = this.strip(this.answer.questionText);
        this.questionTitle = this.strip(this.answer.questionTitle);
      }

      this.gridApi = this.gridOptions.api;
      this.gridApi.sizeColumnsToFit();
    }
  }

</script>

<style lang="scss">
  .ag-grid-table {
    height: calc(100vh - 33rem) !important;
    border: 0.5px solid #e2e2e2 !important;

    &.ag-theme-material {
      .ag-header-cell {
        border-right: solid .1pt #eaeaea !important;
        &:hover {
          background-color: rgb(220, 220, 220) !important;
        }
      }
    }

    .ag-cell-focus:not(.ag-cell-range-selected) {
      border: 1px solid !important;
      border-color: #3f51b5 !important;
    }

    .ag-cell {
      cursor: pointer;
      border-right: solid .1pt #eaeaea !important;
      border-left: solid .1pt #eaeaea !important;
      &:hover {
        background-color: rgb(220, 220, 220) !important;
      }
    }
  }
</style>
